module.exports = __webpack_public_path__ + "img/Flag_of_Puerto_Rico.414c3e6a.svg";